import { render } from "./SendOtp.vue?vue&type=template&id=566ebfe0&scoped=true"
import script from "./SendOtp.vue?vue&type=script&lang=js"
export * from "./SendOtp.vue?vue&type=script&lang=js"

import "./SendOtp.vue?vue&type=style&index=0&id=566ebfe0&lang=scss&scoped=true"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566ebfe0"]])

export default __exports__